import { DEFAULT_ADDRESS, CREDIT_CARD } from '@js/service/checkoutService';

export default {
	user: null,
	cart: null,

	brand: null,

	bumpers: [],

	query: {},
	params: {},

	email: '',
	password: null,

	initialized: false,
	submittingOrder: false,
	modifyingCart: false,

	billingAddress: { ...DEFAULT_ADDRESS },
	shippingAddress: { ...DEFAULT_ADDRESS },
	shippingDifferentFromBilling: false,

	errors: [],
	showFormErrors: false,

	checkingEmailExists: false,
	emailExistsError: false,

	productLimits: [],

	billingPostalCodeMismatchError: false,
	shippingPostalCodeMismatchError: false,

	billingComponent: null,
	billingGateway: null,
	getToken: null,

	showBumperDialog: false,

	paymentProcessor: CREDIT_CARD,
	paymentProcessors: [],

	initializingPaypal: false,
	processingPaypal: false,
	isEcommerce: false,
};
